// extracted by mini-css-extract-plugin
export var footer = "_re-0";
export var inherit = "_re-1";
export var input = "_re-2";
export var modalContent = "_re-3";
export var quillEditor = "_re-4";
export var subtitle = "_re-5";